import React, { useState } from 'react';
import performApiRequest from '../utils/performApiRequest';
import { API_ENDPOINTS } from '../utils/endpoints';
import { useToast } from '../context/useToast';

interface DownloadExcelButtonProps {
    id: string;
    entity: string
}

export const DownloadParticularExcelButton: React.FC<DownloadExcelButtonProps> = ({ id, entity }) => {
  const [isLoading, setIsLoading] = useState(false);
	const { showSuccessToast, showErrorToast } = useToast();

    const handleDownload = async () => {
      setIsLoading(true);
  
      try {
        const requestOptions = {
          method: 'POST',
          responseType: 'blob'
        }

        let endpoint = '';
        if (entity === 'travelAllowanceRequest') {
          endpoint = API_ENDPOINTS.downloadExcelReportFromTravelAllowanceRequest;
        } else if (entity === 'expenseReportRequest') {
          endpoint = `${API_ENDPOINTS.downloadParticularExpenseReportExcelSheet}/${id}`;
        } else if (entity === 'particularExpenseDataTransfer') {
          endpoint = `${API_ENDPOINTS.downloadExcelExpenseDataTransfer}/${id}`;
        }
        
        const response = await performApiRequest(
          endpoint,
          requestOptions
        )
  
        const blob = await response.data;
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
  
        const filename = response.headers.get('Content-Disposition')?.split('filename=')[1] || 'report.xlsx';
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click();
  
        window.URL.revokeObjectURL(downloadUrl);
        a.remove();
		    showSuccessToast('Archivo descargado exitosamente.')
      } catch (error) {
        console.error('Download failed:', error);
        showErrorToast('Hubo un error en la descarga del archivo.')
      } finally {
        setIsLoading(false);
      }
    };
  
    if (entity === 'particularExpenseDataTransfer') {
      return (
        <button onClick={handleDownload} disabled={isLoading} className="bg-blue-600 text-white py-1 px-2 w-5/12 my-6 justify-center mr-1">
          {isLoading ? 'Generando reporte y descargando...' : 'Descargar Data Transfer'}
        </button>
      );
    }

    return (
      <button onClick={handleDownload} disabled={isLoading} className="bg-blue-600 text-white py-1 px-2 w-5/12 my-6 justify-center mr-1">
        {isLoading ? 'Generando reporte y descargando...' : 'Descargar planilla'}
      </button>
    );
}
  